import { Component, OnInit, ViewChild } from '@angular/core';
import { AjoutDocteurComponent, NgbdModalContent_I } from 'app/page/modal/ajout-docteur/ajout-docteur.component';
import { Input } from '@angular/core/src/metadata/directives';
import { Popup } from 'ng2-opd-popup';
import { AdminService } from '../../services/admin';

import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NgbdModalContent } from '../modal/ajout-docteur-tsz/ajout-docteur-tsz.component';

import {  NgbdModalContent_o } from '../modal/ajout-docteur/video-dr-onja/video-dr-onja.component';
import { NgbdModalContent_v } from '../modal/ajout-docteur/video-dr-vony/video-dr-vony.component';
import { NgbdModalContent_r } from '../modal/ajout-docteur/video-dr-rina/video-dr-rina.component';

import { Message } from 'model/modal-cms/message';
import { CMSService } from '../../services/cms-service';
declare var mdtoast: any;
import Swal from 'sweetalert2'
var success_message = mdtoast("Statistique de consultation médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message2 = mdtoast("Statistique de répos médicale. Chargement de donnée...", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message3 = mdtoast("Statistique de remboursement. Chargement de donnée... ", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var success_message4 = mdtoast("Message, bien envoyer.", { duration: 5000, init: true, type: mdtoast.SUCCESS });





@Component({
  selector: 'app-medecin',
  templateUrl: './medecin.component.html',
  styleUrls: ['./medecin.component.scss']
})
export class MedecinComponent implements OnInit {
  focus: any;
  focus1: any;
  @ViewChild('popup5') popup5: Popup;
  lieu_actuel: any;
    id_agent_actuel:any;
  message: Message = new Message(null);
  constructor(
    private modalService: NgbModal,
    //,
    //public activeModal: NgbActiveModal
    private adminService: AdminService,private router: Router,private cMSService : CMSService
  ) { this.id_agent_actuel = this.adminService.getUserIMIscrit();
  }

  

  ngOnInit() {
    this.adminService.newCribSubect2.subscribe(
      data => {
        console.log("Teste paste value in menu navbar Component :" + data);
        this.lieu_actuel = data;
        if (this.lieu_actuel == 1) {
          console.log("ans:" + data);
          // this.nom_dr="Dr Imisa" 

        } else if (this.lieu_actuel == 2) {
          console.log("tsz:" + data);
          // this.nom_dr="Dr Onja" 
          // this.mode_dr=2
        } else if (this.lieu_actuel == 3) {
          console.log("ant:" + data);
          // this.nom_dr="Dr Onja" 
          // this.mode_dr=2
        }


      }
    );
  }

  open22(id: any) {
    this.adminService.setUserId(id);
    console.log(id)
    const modalRef = this.modalService.open(NgbdModalContent);
    modalRef.componentInstance.name = 'modal-content';
   
  }

  open_o(id: any) {
    this.adminService.setUserId(id);
    console.log(id)
    const modalRef = this.modalService.open(NgbdModalContent_o);
    modalRef.componentInstance.name = 'modal-content';
   
  }

  open2() {
    this.popup5.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-mbe-attack",
      color: "#A0DE4F",
      showButtons: false,
      animationDuration: 1.5,
      header: "Créer date du centre",
      widthProsentage: 60,
      animation: "fadeInRight",
      confirmBtnContent: "Ajouter"
    }

    this.popup5.show(this.popup5.options);
  }

  Evaluation(id:any){    
    this.router.navigate(['evaluation/'+id]);
  }

  open(id_dr:any){
    if (id_dr == 1) {
      const modalRef = this.modalService.open(NgbdModalContent_I);
    modalRef.componentInstance.name = 'modal-content';
    }else   if (id_dr == 2) {
      const modalRef = this.modalService.open(NgbdModalContent_v);
    modalRef.componentInstance.name = 'modal-content';
    }else   if (id_dr == 3) {
      const modalRef = this.modalService.open(NgbdModalContent_o);
    modalRef.componentInstance.name = 'modal-content';
    }else   if (id_dr == 4) {
      const modalRef = this.modalService.open(NgbdModalContent_r);
    modalRef.componentInstance.name = 'modal-content';
    }
   
  }


  open_swettealert(){
    Swal.fire({
      title: 'Sweet!',
      text: 'Modal with a custom image.',
      imageUrl: './assets/img/cms/cloud2.jpg',
      imageWidth: 400,
      imageHeight: 200,
      imageAlt: 'Custom image',
    })
  }

  EnvoyerMessage(tel,mail,contenu){
    Swal.fire({
      title: 'Envoi message',
      icon: 'info',
      text: contenu,
      // icone: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, Envoyer!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn
        this.message.im_dest= this.id_agent_actuel
       
        this.message.etat_mess ="c"
       this.message.tel_dest = tel;
       this.message.mail_dest = mail;
       this.message.contenue_mess = contenu;
       this.message.date_mess = new Date();
        this.cMSService.saveMessage(this.message)
        .subscribe(data => {
          success_message4.show();  
        }, err => {
          // console.log(JSON.parse(err._body).message);

        })



      

      } else if (result.dismiss === Swal.DismissReason.cancel) {
      //cancel btn
      }
    });

  }

}
